module.exports = __webpack_public_path__ + "img/full_payment_icon.69da7439.svg";